import styled from 'styled-components'

export const Container = styled.div`
  .simplebar-scrollbar:before {
    background-color: var(--border-secondary);
    opacity: 1;
    width: 4px;
  }

  .simplebar-scrollbar.simplebar-visible:before {
    opacity: 1;
  }
`
